import React, {createRef} from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import Input from 'Components/common/Input';
import SelectChoice from 'Components/common/SelectChoice';

// Actions
import {
    getOrderDetails,
    previewTagUploadImage,
    setShipmentsSource,
} from 'Actions/host';

import {
    getTaskDetails,
    getTaskDetailsFromMessage,
    submitTask,
    uploadReceiveImage,
    getSysDict,
    getTaskDetailMessageCount,
    getTaskDetailOneKeyRead,
    updateTaskAssignmentSearchfields,
    setFromTaskDetailToMessageListPage,
} from 'Actions/taskManagement';
import {getStManagementList} from 'Actions/stManagement';
import {setOrderRelatedTaskStatus, setCurrentStNum} from 'Actions/host';
import {T} from 'Actions/translate';
import {QUESTION_TYPE, TAB_FLAG, TASK_STATUS} from 'Utils/constant';
import util from 'Utils/commonUtil';
import Select from 'Components/common/Select';
import SelectInput from 'Components/common/SelectInput';
import BasicButton from 'Components/common/BasicButton';
import BannerImageDialog from 'Components/common/BannerImage';
import Dialog from 'Components/common/DialogImage';
import {openNotification} from 'Actions/notification';
import NativeSelect from '@material-ui/core/NativeSelect';
import 'cross-fetch/polyfill';

// Icons
import {ArrowBackIos} from '@material-ui/icons';

class TaskDetails extends React.Component {
    pager = {
        pageNum: 0,
        pageSize: 10,
        pageTotal: 9999999999999,
    };
    inputFileRef = createRef();
    state = {
        showTip: false,
        selectedOptions: [], // 初始化选中的选项为空数组
        taskDetailsData: {},
        uploadImageDialogOpened: false,
        currentUploadImageId: 0,
        showSelfFillInforFlag: false,
        searchStQueryKey: '',
        currentQuestionIndex: '',
        currentOptionIndex: '',
        loading: false,
        customerStList: [],
        chooseImage: null,
        previewImageDialogOpened: false,
        closenessId: '',
        contactObj: '',
        messageCount: {},
        notSearchStListFlag: false,
        showImages: false,
        activeImageIndex: 0,
        autoPlayInterval: null, // 自动轮播的定时器
        showLargeImageModal: false,
        currentLargeImage: null,
        isHovered: false, // 鼠标是否悬停在轮播图上
        pauseAutoPlay: false, // 是否暂停自动轮播
        submitSuccessStatus: false,
        isSubmitting: false, // 提交状态
    };

    componentDidUpdate(prevProps, prevState) {
        const {taskDetailsData} = this.state;
        if (taskDetailsData.images !== prevState.taskDetailsData.images) {
            clearInterval(this.state.autoPlayInterval);
            if (taskDetailsData.images && taskDetailsData.images.length > 0) {
                this.autoPlay();
            }
        }
    }

    // 组件卸载时清除定时器
    componentWillUnmount() {
        clearInterval(this.state.autoPlayInterval);
        // 清理事件监听
        document.removeEventListener('click', this.handleClickOutside);
        clearInterval(this.state.autoPlayInterval);
    }
    componentWillMount() {
        if (this.getFromTaskMessageFlag()) {
            this.getMessageDetailsData();
        } else {
            this.getInitData();
        }
        this.getSysDictList();
    }

    getSysDictList = () => {
        let dictType = 'closeness_list';
        this.props.getSysDict(dictType).then((res) => {
            console.log('getSysDictList res', res);
            const {closenessList} = this.props;
        });
    };

    getRoteParam = () => {
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );

        return routerState;
    };

    getFromTaskMessageFlag = () => {
        let fromTaskMessageFlag =
            typeof this.getRoteParam().fromTaskMessageFlag !== 'undefined' &&
            this.getRoteParam().fromTaskMessageFlag;

        return fromTaskMessageFlag;
    };

    getFromShipmentManagementFlag = () => {
        let fromShipmentManagementFlag =
            typeof this.getRoteParam().fromShipmentManagementFlag !==
                'undefined' && this.getRoteParam().fromShipmentManagementFlag;

        return fromShipmentManagementFlag;
    };

    getTabFlag = () => {
        let tabFlag =
            typeof this.getRoteParam().tabFlag !== 'undefined' &&
            this.getRoteParam().tabFlag;

        return tabFlag;
    };

    getMessageDetailsData = () => {
        let taskLogId =
            typeof this.getRoteParam().taskLogId !== 'undefined' &&
            this.getRoteParam().taskLogId;

        let tabFlag =
            typeof this.getRoteParam().tabFlag !== 'undefined' &&
            this.getRoteParam().tabFlag;
        let params = {
            taskLogId: taskLogId,
        };
        this.props.getTaskDetailsFromMessage(params).then((res) => {
            if (res && res.status === 'success' && res.data) {
                let currentTaskDetailsData = JSON.parse(
                    JSON.stringify(res.data),
                );

                if (tabFlag === TAB_FLAG.TO_BE_COMPLETED) {
                    currentTaskDetailsData.contact = '';
                    currentTaskDetailsData.positionName = '';
                    currentTaskDetailsData.closeness = '';
                }

                currentTaskDetailsData.taskQuestions &&
                    currentTaskDetailsData.taskQuestions.length > 0 &&
                    currentTaskDetailsData.taskQuestions.forEach((task) => {
                        task.questionsOptions.forEach((option) => {
                            // if (!option.hasOwnProperty('checked')) {
                            //     option.checked = false;
                            // }
                            if (tabFlag === TAB_FLAG.TO_BE_COMPLETED) {
                                option.checked = false;
                                if (!option.hasOwnProperty('fileName')) {
                                    option.fileName = '';
                                }
                                if (!option.hasOwnProperty('fileUrl')) {
                                    option.fileUrl = '';
                                }
                            }
                        });
                    });
                console.log(
                    'getInitData closenessId111111',
                    this.state.closenessId,
                );
                this.setState(
                    {
                        taskDetailsData: currentTaskDetailsData,
                        closenessId: currentTaskDetailsData.closeness,
                    },
                    () => {
                        console.log(
                            'getInitData closenessId222222',
                            this.state.closenessId,
                        );
                        const {taskDetailsData} = this.state;
                        if (taskDetailsData && taskDetailsData.taskLogId) {
                            this.getTaskDetailsMessage();
                        }
                    },
                );
            }
        });
    };

    getInitData = () => {
        let taskId =
            typeof this.getRoteParam().taskId !== 'undefined' &&
            this.getRoteParam().taskId;
        let id =
            typeof this.getRoteParam().id !== 'undefined' &&
            this.getRoteParam().id;
        let tabFlag =
            typeof this.getRoteParam().tabFlag !== 'undefined' &&
            this.getRoteParam().tabFlag;
        let item =
            typeof this.getRoteParam().item !== 'undefined' &&
            this.getRoteParam().item;

        let params = {
            taskId: taskId,
            customerId: id,
        };
        this.props.getTaskDetails(params).then((res) => {
            if (res && res.status === 'success' && res.data) {
                let currentTaskDetailsData = JSON.parse(
                    JSON.stringify(res.data),
                );

                if (tabFlag === TAB_FLAG.TO_BE_COMPLETED) {
                    currentTaskDetailsData.contact = '';
                    currentTaskDetailsData.positionName = '';
                    currentTaskDetailsData.closeness = '';
                }

                currentTaskDetailsData.taskQuestions &&
                    currentTaskDetailsData.taskQuestions.length > 0 &&
                    currentTaskDetailsData.taskQuestions.forEach((task) => {
                        task.questionsOptions.forEach((option) => {
                            // if (!option.hasOwnProperty('checked')) {
                            //     option.checked = false;
                            // }
                            if (tabFlag === TAB_FLAG.TO_BE_COMPLETED) {
                                option.checked = false;
                                if (!option.hasOwnProperty('fileName')) {
                                    option.fileName = '';
                                }
                                if (!option.hasOwnProperty('fileUrl')) {
                                    option.fileUrl = '';
                                }
                            }
                        });
                    });
                console.log(
                    'getInitData closenessId111111',
                    this.state.closenessId,
                );
                this.setState(
                    {
                        taskDetailsData: currentTaskDetailsData,
                        // closenessId: currentTaskDetailsData.closeness,
                    },
                    () => {
                        const {taskDetailsData} = this.state;
                        this.setState({
                            closenessId: currentTaskDetailsData.closeness,
                        });
                        if (taskDetailsData && taskDetailsData.taskLogId) {
                            this.getTaskDetailsMessage();
                        }
                    },
                );
            }
        });
    };

    getTaskDetailsMessage = () => {
        const {taskDetailsData} = this.state;
        this.props
            .getTaskDetailMessageCount({
                messageKey: taskDetailsData.taskLogId,
                messageMode: 'TASK',
            })
            .then((res) => {
                if (res && res.status === 'success' && res.data) {
                    this.setState({
                        messageCount: res.data,
                    });
                }
            });
    };

    getAssignmentShipto = () => {
        let item =
            typeof this.getRoteParam().item !== 'undefined' &&
            this.getRoteParam().item;

        let shipTo = item && item.shipTo ? item.shipTo : '';

        return shipTo;
    };

    goBack = () => {
        if (this.getFromTaskMessageFlag()) {
            this.props.setFromTaskDetailToMessageListPage({$set: true});
            this.props.history.goBack();
        } else if (this.getFromShipmentManagementFlag()) {
            let toBeReceveShipmentItem =
                typeof this.getRoteParam().toBeReceveShipmentItem !==
                    'undefined' && this.getRoteParam().toBeReceveShipmentItem;

            if (this.state.submitSuccessStatus) {
                this.props.setCurrentStNum({
                    $set: toBeReceveShipmentItem.shipToNum,
                });
                this.setState({
                    submitSuccessStatus: false,
                });
            } else {
                this.props.setCurrentStNum({
                    $set: '',
                });
            }

            this.props.setShipmentsSource({$set: true});
            this.props.setOrderRelatedTaskStatus({$set: true});
            this.props.history.goBack();
        } else {
            this.props.updateTaskAssignmentSearchfields({
                queryKey: {$set: ''},
            });
            this.props.history.goBack();
        }
    };

    goBackToShipmentList = () => {
        if (this.getFromShipmentManagementFlag()) {
            let toBeReceveShipmentItem =
                typeof this.getRoteParam().toBeReceveShipmentItem !==
                    'undefined' && this.getRoteParam().toBeReceveShipmentItem;

            if (this.state.submitSuccessStatus) {
                this.props.setCurrentStNum({
                    $set: toBeReceveShipmentItem.shipToNum,
                });
            }

            this.props.setShipmentsSource({$set: true});
            this.props.setOrderRelatedTaskStatus({$set: true});
            this.props.history.goBack();
        }
    };

    handleChangeSelect = (index, optionIndex, checked) => {
        let tempAllQuestion = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (tempOptionIndex === index) {
                        tempOptionItem &&
                            tempOptionItem.questionsOptions &&
                            tempOptionItem.questionsOptions.length > 0 &&
                            tempOptionItem.questionsOptions.map(
                                (opt, subOptIndex) => {
                                    if (optionIndex === subOptIndex) {
                                        opt.checked = !checked;
                                    }
                                },
                            );
                    }
                },
            );

        console.log('tempAllOptions', tempAllQuestion);
        this.setState({
            taskDetailsData: tempAllQuestion,
        });
    };

    handleChangeRadioSelect = (index, optionIndex, checked) => {
        let tempAllQuestion = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (tempOptionIndex === index) {
                        tempOptionItem &&
                            tempOptionItem.questionsOptions &&
                            tempOptionItem.questionsOptions.length > 0 &&
                            tempOptionItem.questionsOptions.map(
                                (opt, subOptIndex) => {
                                    if (optionIndex !== subOptIndex) {
                                        opt.checked = false;
                                    } else {
                                        opt.checked = true;
                                    }
                                },
                            );
                    }
                },
            );

        console.log('tempAllOptions', tempAllQuestion);
        this.setState({
            taskDetailsData: tempAllQuestion,
        });
    };

    handleGapFillingChange = (title, value) => {
        let tempAllQuestion = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        let taskIndex = parseInt(title.split('-')[1]);
        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (taskIndex === tempOptionIndex) {
                        tempOptionItem.questionsOptions[0].inputText = value;
                    }
                },
            );

        this.setState(
            {
                taskDetailsData: tempAllQuestion,
            },
            () => {
                // console.log("handleGapFillingChange taskDetailsData", this.state.taskDetailsData);
            },
        );
    };

    handleOptionInputChange = (title, value) => {
        let tempAllQuestion = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        let taskIndex = parseInt(title.split('-')[1]);
        let questionOptionIndex = parseInt(title.split('-')[2]);
        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (taskIndex === tempOptionIndex) {
                        tempOptionItem.questionsOptions.length > 0 &&
                            tempOptionItem.questionsOptions.map(
                                (qOption, qIndex) => {
                                    if (qIndex === questionOptionIndex) {
                                        qOption.inputText = value;
                                    }
                                },
                            );
                    }
                },
            );

        this.setState(
            {
                taskDetailsData: tempAllQuestion,
            },
            () => {
                // console.log("handleOptionInputChange taskDetailsData", this.state.taskDetailsData);
            },
        );
    };

    openOptionImageHandle = (currentQuestionIndex, currentOptionIndex) => {
        this.setState({
            currentQuestionIndex: currentQuestionIndex,
            currentOptionIndex: currentOptionIndex,
            uploadImageDialogOpened: true,
            chooseImage: null,
            loading: false,
        });
    };

    deleteUploadFileHandle = (taskIndex, questionOptionIndex) => {
        let tempAllQuestion = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );

        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (taskIndex === tempOptionIndex) {
                        tempOptionItem.questionsOptions.length > 0 &&
                            tempOptionItem.questionsOptions.map(
                                (qOption, qIndex) => {
                                    if (qIndex === questionOptionIndex) {
                                        qOption.fileName = '';
                                        qOption.fileUrl = '';
                                    }
                                },
                            );
                    }
                },
            );

        this.setState(
            {
                taskDetailsData: tempAllQuestion,
            },
            () => {
                // console.log("handleOptionInputChange taskDetailsData", this.state.taskDetailsData);
            },
        );
    };

    dialogDidClose = (dialog) => {
        if (dialog === 'uploadImageDialogOpened') {
            document.getElementById('root').style.position = 'initial';
        }
        this.state[dialog] && this.setState({[dialog]: false});
    };

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }
        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };

    uploadConfirmHandle = () => {
        this.setState({
            loading: true,
        });

        if (this.state.chooseImage) {
            this.props
                .uploadReceiveImage({
                    type: 'task',
                    file: this.state.chooseImage.file,
                })
                .then((res) => {
                    console.log('uploadConfirmHandle res', res);
                    if (res && res.status === 'success') {
                        this.props.openNotification(
                            T('notification_successfully_upload'),
                            'success',
                        );
                        this.updateUploadFileContent(res);
                    }
                })
                .catch((e) => {
                    document.getElementById('root').style.position = 'relative';
                    this.refs['inputFile'].value = null;
                    this.setState({loading: false, chooseImage: null});
                    // this.props.openNotification(
                    //     T('notification_picture_upload_failed'),
                    //     'danger',
                    // );
                });
        } else {
            this.setState({
                loading: false,
            });
            this.props.openNotification(
                T('host_advent_products_upload_tag_is_not_null'),
                'danger',
            );
        }
    };

    updateUploadFileContent = (res) => {
        const {currentQuestionIndex, currentOptionIndex, taskDetailsData} =
            this.state;
        let tempAllQuestion = JSON.parse(JSON.stringify(taskDetailsData));

        tempAllQuestion &&
            tempAllQuestion.taskQuestions.length > 0 &&
            tempAllQuestion.taskQuestions.map(
                (tempOptionItem, tempOptionIndex) => {
                    if (currentQuestionIndex === tempOptionIndex) {
                        tempOptionItem.questionsOptions.length > 0 &&
                            tempOptionItem.questionsOptions.map(
                                (qOption, qIndex) => {
                                    if (qIndex === currentOptionIndex) {
                                        qOption.fileName = res.name;
                                        qOption.fileFullUrl = res.url;
                                        qOption.fileUrl = res.url;
                                    }
                                },
                            );
                    }
                },
            );

        this.setState(
            {
                taskDetailsData: tempAllQuestion,
                uploadImageDialogOpened: false,
                loading: false,
            },
            () => {
                console.log(
                    'updateUploadFileContent taskDetailsData',
                    this.state.taskDetailsData,
                );
            },
        );
    };

    getClosenessName = (closeness) => {
        const {closenessList} = this.props;
        let currentClosenessName = '';
        let currentClosenessList = JSON.parse(JSON.stringify(closenessList));

        for (const item of currentClosenessList) {
            if (item.key === closeness) {
                currentClosenessName = item.value;
                return currentClosenessName;
            }
        }
    };

    getQueryCustomerList = (cusotmerInfo) => {
        let customerList = [];
        cusotmerInfo &&
            cusotmerInfo.length > 0 &&
            cusotmerInfo.map((customerItem, customerIndex) => {
                let customerName = [
                    customerItem.contact,
                    customerItem.positionName,
                    this.getClosenessName(customerItem.closeness),
                ]
                    .filter(Boolean)
                    .join(' ');

                let customerObj = {
                    id: customerIndex + 1,
                    name: customerName,
                    closenessValue: this.getClosenessName(
                        customerItem.closeness,
                    ),
                };
                if (customerName) {
                    customerList.push(customerObj);
                }
            });
        customerList.push({
            id: cusotmerInfo.length + 1,
            notAllFlag: true,
            name: '都不是',
        });

        console.log('customerList', customerList);
        return customerList;
    };

    handleSelectCustomerChange = (item) => {
        console.log('handleSelectCustomerChange item', item);
        const {taskDetailsData} = this.state;
        let currentTaskDetailsData = JSON.parse(
            JSON.stringify(taskDetailsData),
        );

        let showSelfFillingArea = true;
        if (typeof item.notAllFlag !== 'undefined' && item.notAllFlag) {
            currentTaskDetailsData.contact = '';
            currentTaskDetailsData.positionName = '';
            currentTaskDetailsData.closeness = '';
        } else {
            currentTaskDetailsData &&
                currentTaskDetailsData.customerInfo &&
                currentTaskDetailsData.customerInfo.length > 0 &&
                currentTaskDetailsData.customerInfo.map(
                    (cusotmerItem, customerIndex) => {
                        if (
                            customerIndex + 1 === item.id &&
                            typeof item.notAllFlag === 'undefined'
                        ) {
                            currentTaskDetailsData.contact =
                                cusotmerItem.contact;
                            currentTaskDetailsData.positionName =
                                cusotmerItem.positionName;
                            currentTaskDetailsData.closeness =
                                cusotmerItem.closeness;
                        }
                    },
                );
        }

        this.setState(
            {
                showSelfFillInforFlag: showSelfFillingArea,
                taskDetailsData: currentTaskDetailsData,
            },
            () => {
                console.log(
                    'getInitData closenessId333333',
                    this.state.closenessId,
                );
                this.setState({
                    closenessId: this.state.taskDetailsData.closeness,
                });
            },
        );
    };

    handleChangeInput = (title, value) => {
        console.log(title, value);
        const {taskDetailsData} = this.state;
        let currentTaskDetailsData = JSON.parse(
            JSON.stringify(taskDetailsData),
        );

        if (title === 'closeness') {
            currentTaskDetailsData.closeness = value;
        } else if (title === 'position') {
            currentTaskDetailsData.positionName = value;
        } else if (title === 'contact') {
            currentTaskDetailsData.contact = value;
        }

        this.setState({
            taskDetailsData: currentTaskDetailsData,
        });
    };

    handleSelectClosenessChange = (item) => {
        let currentTaskDetailsData = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        currentTaskDetailsData.closeness = item.key;

        console.log('getInitData closenessId444444', this.state.closenessId);
        this.setState({
            taskDetailsData: currentTaskDetailsData,
            closenessId: item.key,
        });
    };

    focusInput = () => {
        this.setState({
            SClist: this.state.customerStList,
        });
    };

    clearInput = (name, value, serachFlg) => {
        if (name === 'searchStQueryKey') {
            const {taskDetailsData} = this.state;
            let currentTaskDetailsData = JSON.parse(
                JSON.stringify(taskDetailsData),
            );
            currentTaskDetailsData.shipTo = '';
            currentTaskDetailsData.stAlphaName = '';
            this.setState({
                taskDetailsData: currentTaskDetailsData,
            });
        }
    };

    handleSearch = (name, value, serachFlg) => {
        this.setState({
            searchStQueryKey: value,
        });

        console.log(
            'handleSearch this.props.closenessList',
            this.props.closenessList,
        );
        if (typeof value !== 'string') {
            console.log(
                "handleSearch value !== 'string' name, value",
                name,
                value,
            );
            const {taskDetailsData} = this.state;
            let currentTaskDetailsData = JSON.parse(
                JSON.stringify(taskDetailsData),
            );
            currentTaskDetailsData.shipTo = value.id;
            currentTaskDetailsData.stAlphaName = value.fullName;
            this.setState({
                taskDetailsData: currentTaskDetailsData,
            });
        } else {
            console.log('handleSearch value', value);
            console.log('handleSearch serachFlg', serachFlg);
            if (serachFlg) {
                const {taskDetailsData} = this.state;
                let currentTaskDetailsData = JSON.parse(
                    JSON.stringify(taskDetailsData),
                );
                currentTaskDetailsData.shipTo = '';
                currentTaskDetailsData.stAlphaName = '';
                this.setState({
                    taskDetailsData: currentTaskDetailsData,
                });
            } else {
                let taskDetailsData = this.state.taskDetailsData;
                let params = {
                    pageNum: this.pager.pageNum + 1,
                    pageSize: this.pager.pageSize,
                    key: value ? value.trim() : '',
                    scIds:
                        taskDetailsData && taskDetailsData.supplyCenterId
                            ? [taskDetailsData.supplyCenterId]
                            : [],
                };
                this.props.getStManagementList(params).then((res) => {
                    console.log('handleSearch res', res);
                    if (res && res.status === 'success') {
                        let tempStList = [];
                        let allStList = JSON.parse(JSON.stringify(res.data));

                        allStList.length > 0 &&
                            allStList.map((stItem, stIndex) => {
                                let stObj = {
                                    id: stItem.shipTo,
                                    fullName: stItem.stAlphaName,
                                };
                                tempStList.push(stObj);
                            });

                        this.setState({
                            customerStList: tempStList,
                            notSearchStListFlag: this.isShowSearchStListFlag(
                                tempStList,
                                value,
                            ),
                        });
                    }
                });
            }
        }
    };

    isShowSearchStListFlag = (tempStList, value) => {
        let searchStListFlag = false;
        if (value && tempStList.length <= 0) {
            searchStListFlag = true;
        }

        return searchStListFlag;
    };

    checkIfEmpty = (ta) => {
        let isEmpty = true; // 初始假设所有必填项都未被选中

        for (const item of ta) {
            if (item.isRequired) {
                let allUnchecked = true; // 假设当前项的所有选项都未被选中

                let questionType = item.questionType;
                if (questionType === QUESTION_TYPE.GQP_FILLING) {
                    if (item.questionsOptions[0].inputText) {
                        allUnchecked = false;
                    }
                } else {
                    item.questionsOptions.forEach((option) => {
                        if (option.checked) {
                            allUnchecked = false; // 只要有一个被选中，就设置为 false
                        }
                    });
                }

                if (allUnchecked) {
                    // 如果当前项的所有选项都未被选中，保持 isEmpty 为 true
                    isEmpty = true;
                    return isEmpty;
                } else {
                    // 如果当前项的至少一个选项被选中，则 isEmpty 应该为 false
                    isEmpty = false;
                }
            } else {
                isEmpty = false;
            }
        }

        console.log('saveTask isEmpty', isEmpty);
        // 最终返回 isEmpty 的值
        return isEmpty;
    };
    requiredQuestionNotEmpty = () => {
        const {taskDetailsData} = this.state;

        let tempAllQuestion = JSON.parse(JSON.stringify(taskDetailsData));

        let result = this.checkIfEmpty(tempAllQuestion.taskQuestions);

        return result;
    };

    checkInputContentLength = () => {
        const {taskDetailsData} = this.state;

        let tempAllQuestion = JSON.parse(JSON.stringify(taskDetailsData));

        if (
            tempAllQuestion &&
            tempAllQuestion.taskQuestions &&
            tempAllQuestion.taskQuestions.length > 0
        ) {
            for (const questionItem of tempAllQuestion.taskQuestions) {
                let qOptions = questionItem.questionsOptions;
                for (const qOptionItem of qOptions) {
                    if (
                        qOptionItem.inputText &&
                        qOptionItem.inputText.length > 100
                    ) {
                        return false;
                    }
                }
            }
        }

        return true;
    };

    isSelectStFlag = () => {
        const {searchStQueryKey, customerStList} = this.state;
        let isSelectStFlag = false;

        if (typeof searchStQueryKey !== 'string') {
            isSelectStFlag = true;
        } else {
            isSelectStFlag = false;
            // if (
            //     customerStList &&
            //     customerStList.length > 0 &&
            //     searchStQueryKey
            // ) {
            //     customerStList.map((customerSt, customerStIndex) => {
            //         if (
            //             customerSt.id === searchStQueryKey ||
            //             customerSt.fullName === searchStQueryKey
            //         ) {
            //             isSelectStFlag = true;
            //         }
            //     });
            // }
        }

        return isSelectStFlag;
    };

    saveTask = () => {
        const {taskDetailsData, notSearchStListFlag, searchStQueryKey} =
            this.state;
        // console.log('saveTask taskDetailsData', taskDetailsData);
        // console.log('saveTask notSearchStListFlag', notSearchStListFlag);
        if (
            (searchStQueryKey && !this.isSelectStFlag()) ||
            notSearchStListFlag
        ) {
            this.props.openNotification(
                T('task_details_please_dropdown_select_customer'),
                'danger',
            );
        } else if (
            taskDetailsData.contact &&
            taskDetailsData.contact.length > 30
        ) {
            this.props.openNotification(
                T('task_details_contact_max_30'),
                'danger',
            );
        } else if (
            taskDetailsData.positionName &&
            taskDetailsData.positionName.length > 20
        ) {
            this.props.openNotification(
                T('task_details_position_max_20'),
                'danger',
            );
        } else if (this.requiredQuestionNotEmpty()) {
            this.props.openNotification(
                T('task_details_required_not_do'),
                'danger',
            );
        } else if (!this.checkInputContentLength()) {
            this.props.openNotification(
                T('task_details_input_content_max_100'),
                'danger',
            );
        } else {
            delete taskDetailsData.files;
            delete taskDetailsData.images;
            this.setState(
                {
                    isSubmitting: true,
                },
                () => {
                    this.props.submitTask(taskDetailsData).then((res) => {
                        // console.log('saveTask', res);
                        if (res && res.status === 'success') {
                            this.setState({
                                submitSuccessStatus: true,
                                isSubmitting: false,
                            });
                            this.props.openNotification(
                                T('task_details_submit_success'),
                                'success',
                            );

                            if (this.getFromShipmentManagementFlag()) {
                                this.goBackToShipmentList();
                            } else {
                                this.goBack();
                            }
                        }
                    });
                },
            );
        }
    };

    getCloseness = () => {
        const {closenessList} = this.props;
        const {taskDetailsData} = this.state;
        let currentCloseness = '';

        let currentClosenessList = JSON.parse(JSON.stringify(closenessList));

        currentClosenessList &&
            currentClosenessList.length > 0 &&
            currentClosenessList.map((closeness) => {
                if (closeness.key === taskDetailsData.closeness) {
                    currentCloseness = closeness.value;
                }
            });

        return currentCloseness;
    };

    handleChange = (name) => (event) => {
        let currentTaskDetailsData = JSON.parse(
            JSON.stringify(this.state.taskDetailsData),
        );
        currentTaskDetailsData.closeness = event.target.value;

        console.log('getInitData closenessId555555', this.state.closenessId);
        this.setState({
            taskDetailsData: currentTaskDetailsData,
            closenessId: event.target.value,
        });
    };

    renderContactInfor = (taskDetailsData) => {
        const {closenessList} = this.props;
        const {closenessId} = this.state;
        console.log('renderContactInfor closenessId', this.state.closenessId);
        console.log('renderContactInfor closenessList', closenessList);

        return (
            <div className="self-fill-info">
                <p className="group-name">
                    <div className="contact-header">
                        {T('task_details_contact')}：
                    </div>
                    <Input
                        placeholder={T('task_details_please_input_contact')}
                        type="text"
                        title="contact"
                        onChange={this.handleChangeInput}
                        value={taskDetailsData.contact}
                        required="false"
                        disabled={util.isDisabledQuestion(
                            this.getTabFlag(),
                            taskDetailsData.taskStatus,
                        )}
                    />
                </p>
                <p className="group-phone">
                    <div className="contact-header">
                        {T('task_details_position')}：
                    </div>
                    <Input
                        placeholder={T('task_details_please_input_position')}
                        type="text"
                        title="position"
                        onChange={this.handleChangeInput}
                        value={taskDetailsData.positionName}
                        required="false"
                        onBlur={this.onBlur}
                        disabled={util.isDisabledQuestion(
                            this.getTabFlag(),
                            taskDetailsData.taskStatus,
                        )}
                    />
                </p>
                <p className="group-closeness">
                    <div className="contact-header">
                        {T('task_details_closeness')}：
                    </div>

                    {util.isDisabledQuestion(
                        this.getTabFlag(),
                        taskDetailsData.taskStatus,
                    ) ? (
                        <Input
                            placeholder=""
                            type="text"
                            title="closeness"
                            onChange={this.handleChangeInput}
                            value={this.getCloseness()}
                            required="false"
                            onBlur={this.onBlur}
                            disabled={util.isDisabledQuestion(
                                this.getTabFlag(),
                                taskDetailsData.taskStatus,
                            )}
                        />
                    ) : (
                        closenessList.length > 0 && (
                            <Select
                                className="select"
                                value={closenessId}
                                placeholder={T(
                                    'task_details_please_select_closeness',
                                )}
                                data={closenessList}
                                displayKey="value"
                                valueKey="key"
                                currentFunction="taskdetail"
                                onChange={this.handleSelectClosenessChange}
                                options={{icon: {show: true, color: '#E82D38'}}}
                                disabled={util.isDisabledQuestion(
                                    this.getTabFlag(),
                                )}
                            />
                        )

                        // <NativeSelect
                        //     className="closeness-select-wrapper"
                        //     value={closenessId || ''}
                        //     name="closeness"
                        //     onChange={this.handleChange('closeness')}
                        //     style={{fontSize: '0.8rem'}}>
                        //     <option className="select-empty-option" value="">
                        //         {'请选择亲密度'}
                        //     </option>
                        //     {closenessList &&
                        //         closenessList.length > 0 &&
                        //         closenessList.map(
                        //             (closenessItem, closenessIndex) => (
                        //                 <option
                        //                     className="select-option"
                        //                     value={closenessItem.key}style={{
                        //                         '&:hover': {
                        //                             backgroundColor: 'red !important', // 鼠标悬停时的背景色
                        //                             color: 'white', // 悬停时的文字颜色
                        //                         },
                        //                     }}
                        //                     >
                        //                     {closenessItem.value}
                        //                 </option>
                        //             ),
                        //         )}
                        // </NativeSelect>
                    )}
                </p>
            </div>
        );
    };

    goToMessageList = () => {
        const {messageCount, taskDetailsData} = this.state;
        let currentShipmentOrOrderDetails = this.props.shipmentOrOrderDetails;
        if (taskDetailsData && taskDetailsData.taskLogId) {
            if (messageCount.unReadCount > 0) {
                this.props
                    .getTaskDetailOneKeyRead({
                        messageKey: taskDetailsData.taskLogId,
                        messageMode: 'TASK',
                    })
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.props.history.push(
                                `/messageList?eoneNumber=${
                                    taskDetailsData.taskLogId
                                }&messageType=${'TASK'}&messageId=${
                                    taskDetailsData.taskNo
                                }&remark=${taskDetailsData.stAlphaName}`,
                            );
                        }
                    });
            } else {
                this.props.history.push(
                    `/messageList?eoneNumber=${
                        taskDetailsData.taskLogId
                    }&messageType=${'TASK'}&messageId=${
                        taskDetailsData.taskNo
                    }&remark=${taskDetailsData.stAlphaName}`,
                );
            }
        }
    };

    showSTComps = (taskDetailsData) => {
        let showFlag = false;

        if (
            this.getTabFlag() === TAB_FLAG.TO_BE_COMPLETED &&
            !taskDetailsData.stAlphaName
        ) {
            showFlag = true;
        } else if (
            this.getTabFlag() === TAB_FLAG.FOLLOW_UP &&
            !taskDetailsData.stAlphaName &&
            taskDetailsData.taskStatus === 'progress'
        ) {
            showFlag = true;
        }
        return showFlag;
    };

    showSelectContacts = (taskDetailsData) => {
        let showSelectContactsFlag = false;

        if (
            this.getTabFlag() === TAB_FLAG.TO_BE_COMPLETED &&
            taskDetailsData.customerInfo &&
            taskDetailsData.customerInfo.length > 0
        ) {
            showSelectContactsFlag = true;
        } else if (
            this.getTabFlag() === TAB_FLAG.FOLLOW_UP &&
            taskDetailsData.customerInfo &&
            taskDetailsData.customerInfo.length > 0 &&
            taskDetailsData.taskStatus === 'progress'
        ) {
            showSelectContactsFlag = true;
        }
        return showSelectContactsFlag;
    };

    setShowImages = () => {
        this.setState({
            showImages: !this.state.showImages,
        });
    };

    // 切换图片
    changeImage = (index) => {
        this.setState({activeImageIndex: index});
    };

    // 自动轮播
    autoPlay = () => {
        const {taskDetailsData, activeImageIndex} = this.state;
        const totalImages = taskDetailsData.images.length;

        // 清除之前的定时器
        clearInterval(this.state.autoPlayInterval);

        // 设置新的定时器
        const interval = setInterval(() => {
            this.setState((prevState) => ({
                activeImageIndex:
                    (prevState.activeImageIndex + 1) % totalImages,
            }));
        }, 3000); // 每3秒切换一次图片

        this.setState({autoPlayInterval: interval});
    };

    handleImageClick = (image) => {
        this.setState({
            showLargeImageModal: true,
            currentLargeImage: image.fileFullUrl,
        });
    };

    handleMouseEnter = () => {
        this.setState({isHovered: true}); // 鼠标悬停，设置状态为 true
        clearInterval(this.state.autoPlayInterval); // 清除定时器，停止轮播
    };

    handleMouseLeave = () => {
        this.setState({isHovered: false}); // 鼠标移出，设置状态为 false
        if (!this.state.pauseAutoPlay) {
            // 如果自动轮播没有被暂停，重新开始轮播
            this.autoPlay();
        }
    };

    closeBannerImageDialog = () => {
        this.setState({
            showLargeImageModal: false,
            currentLargeImage: null,
        });
    };

    downloadFile = (file, e) => {
        const options = {
            method: 'POST',
        };

        return new Promise((resolve, reject) => {
            fetch(file.fileFullUrl)
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file.fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => console.error('下载失败:', error));
        });
    };

    render() {
        const {
            taskDetailsData,
            showSelfFillInforFlag,
            searchStQueryKey,
            uploadImageDialogOpened,
            loading,
            customerStList,
            chooseImage,
            previewImageDialogOpened,
            closenessId,
            contactObj,
            messageCount,
            notSearchStListFlag,
            showImages,
            activeImageIndex,
            isSubmitting,
        } = this.state;
        let taskQuestions = taskDetailsData && taskDetailsData.taskQuestions;
        console.log('render taskDetailsData', taskDetailsData);
        console.log('render closenessId', closenessId);
        console.log('render task isSubmitting', isSubmitting);

        return (
            <div className="task-details-container">
                <div className="header-wrap">
                    <div className="task-details-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        {T('task_details')}

                        {messageCount && messageCount.messageCount > 0 ? (
                            <div className="message-count-container">
                                {messageCount.unReadCount > 0 ? (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_unread_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                ) : (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_read_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="content-box">
                    <p className="task-name">
                        <div>{taskDetailsData.taskName}</div>
                    </p>
                    <p className="task-desc-wrapper">
                        <div
                            className="task-header"
                            style={{fontWeight: 'bold'}}>
                            {T('task_details_tracking_desc')}
                        </div>
                        <div className="task-content">
                            {taskDetailsData.description}
                        </div>
                    </p>

                    {taskDetailsData.additionalInfo ? (
                        <p className="task-name">
                            <div className="task-header additionally-task-info">
                                {T('task_details_task_info')}
                            </div>
                            {taskDetailsData.additionalInfo}
                        </p>
                    ) : null}

                    {taskDetailsData.trackingStatus ? (
                        <p className="task-name">
                            <div className="task-header additionally-task-info">
                                {T('task_details_tracking_status')}
                            </div>
                            {taskDetailsData.trackingStatus}
                        </p>
                    ) : null}

                    {taskDetailsData.images &&
                    taskDetailsData.images.length > 0 ? (
                        <div
                            className="carousel"
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}>
                            <div className="carousel-images">
                                {taskDetailsData.images.map((image, index) => (
                                    <img
                                        key={index}
                                        src={image.fileFullUrl} // 假设每个图片对象都有 src 属性
                                        alt={`Image ${index}`}
                                        className={
                                            index === activeImageIndex
                                                ? 'image-item active'
                                                : 'image-item'
                                        }
                                        style={{
                                            display:
                                                index === activeImageIndex
                                                    ? 'block'
                                                    : 'none',
                                        }}
                                        onClick={(e) =>
                                            this.handleImageClick(image)
                                        }
                                    />
                                ))}
                            </div>
                            <div class="carousel-controls">
                                {taskDetailsData.images.map(
                                    (bannerItem, index) => (
                                        <span
                                            key={index}
                                            class={
                                                index === activeImageIndex
                                                    ? 'indicator active'
                                                    : 'indicator'
                                            }
                                            onClick={() =>
                                                this.changeImage(index)
                                            }></span>
                                    ),
                                )}
                            </div>
                        </div>
                    ) : null}

                    {taskDetailsData.files &&
                    taskDetailsData.files.length > 0 ? (
                        <div className="files-container">
                            {taskDetailsData.files.map((file, index) =>
                                file.fileFullUrl ? (
                                    <div className="show-file-name">
                                        {/* <a href={file.fileFullUrl}>
                                            {file.fileName}
                                        </a> */}
                                        <div
                                            onClick={(e) =>
                                                this.downloadFile(file, e)
                                            }>
                                            {file.fileName}
                                        </div>
                                    </div>
                                ) : (
                                    <div>{file.fileName}</div>
                                ),
                            )}
                        </div>
                    ) : null}
                </div>

                {taskQuestions ? (
                    util.isDisabledQuestion(
                        this.getTabFlag(),
                        taskDetailsData.taskStatus,
                    ) ? (
                        <div className="content-box">
                            <p className="group-name not-top">
                                <div className="dept-content">
                                    {taskDetailsData.stAlphaName}
                                </div>
                            </p>
                            {this.getTabFlag() === TAB_FLAG.TO_BE_COMPLETED &&
                                taskDetailsData.customerInfo &&
                                taskDetailsData.customerInfo.length > 0 && (
                                    <div className="cusotmer-info-wrapper">
                                        <label className="query-customer-label">
                                            {T('task_details_select_contacts')}
                                        </label>
                                        <Select
                                            className="select"
                                            value={''}
                                            placeholder={T(
                                                'task_details_please_select_contacts',
                                            )}
                                            data={this.getQueryCustomerList(
                                                taskDetailsData.customerInfo
                                                    ? taskDetailsData.customerInfo
                                                    : [],
                                            )}
                                            displayKey="name"
                                            valueKey="id"
                                            onChange={
                                                this.handleSelectCustomerChange
                                            }
                                            options={{
                                                icon: {
                                                    show: true,
                                                    color: '#E82D38',
                                                },
                                            }}
                                        />
                                    </div>
                                )}
                            {showSelfFillInforFlag ||
                            this.getTabFlag() !== TAB_FLAG.TO_BE_COMPLETED ||
                            !taskDetailsData.customerInfo ||
                            (taskDetailsData.customerInfo &&
                                taskDetailsData.customerInfo.length <= 0)
                                ? this.renderContactInfor(taskDetailsData)
                                : null}
                        </div>
                    ) : (
                        <div className="content-box">
                            {taskDetailsData.stAlphaName && (
                                <p className="group-name not-top">
                                    <div className="dept-content">
                                        {taskDetailsData.stAlphaName}
                                    </div>
                                </p>
                            )}

                            {this.showSelectContacts(taskDetailsData) && (
                                <div className="cusotmer-info-wrapper">
                                    <label className="query-customer-label">
                                        {T('task_details_select_contacts')}
                                    </label>
                                    <Select
                                        className="select"
                                        value={''}
                                        placeholder={T(
                                            'task_details_please_select_contacts',
                                        )}
                                        data={this.getQueryCustomerList(
                                            taskDetailsData.customerInfo
                                                ? taskDetailsData.customerInfo
                                                : [],
                                        )}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={
                                            this.handleSelectCustomerChange
                                        }
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                </div>
                            )}
                            {this.showSTComps(taskDetailsData) && (
                                <SelectInput
                                    title={'searchStQueryKey'}
                                    placeholder=""
                                    list={customerStList}
                                    value={searchStQueryKey}
                                    defalutValue={taskDetailsData.shipTo}
                                    inputValid={this.handleSearch}
                                    focusInput={this.focusInput}
                                    currentShipto={taskDetailsData.shipTo}
                                    clearInput={this.clearInput}
                                    type="text"
                                    required={false}
                                />
                            )}
                            {notSearchStListFlag ? (
                                <div className="not-search-st-list">
                                    {T(
                                        'task_details_please_dropdown_select_customer',
                                    )}{' '}
                                </div>
                            ) : null}
                            {taskDetailsData.shipTo
                                ? this.renderContactInfor(taskDetailsData)
                                : null}
                        </div>
                    )
                ) : null}

                {taskQuestions && (
                    <div className="content-box">
                        {taskQuestions.length > 0 &&
                            taskQuestions.map((optionItem, optionIndex) => (
                                <SelectChoice
                                    index={optionIndex}
                                    optionItem={optionItem}
                                    tabFlag={this.getTabFlag()}
                                    taskStatus={taskDetailsData.taskStatus}
                                    handleChangeSelect={this.handleChangeSelect}
                                    handleChangeRadioSelect={
                                        this.handleChangeRadioSelect
                                    }
                                    handleGapFillingChange={
                                        this.handleGapFillingChange
                                    }
                                    handleOptionInputChange={
                                        this.handleOptionInputChange
                                    }
                                    openOptionImageHandle={
                                        this.openOptionImageHandle
                                    }
                                    deleteUploadFileHandle={
                                        this.deleteUploadFileHandle
                                    }
                                />
                            ))}
                    </div>
                )}

                {this.getTabFlag() === TAB_FLAG.TO_BE_COMPLETED ||
                (this.getTabFlag() === TAB_FLAG.FOLLOW_UP &&
                    taskDetailsData.taskStatus === TASK_STATUS.PROGRESS) ? (
                    <div className="assignment-customer-btn-wrapper">
                        <BasicButton
                            type="primary"
                            className="basic-style view-task-btn"
                            onClickOfSingleTap={() => {
                                console.log('haha');
                                this.saveTask();
                            }}
                            disabled={isSubmitting}
                            isStopPropagation={true}>
                            {T('task_details_submit')}
                        </BasicButton>
                    </div>
                ) : null}

                {this.state.showLargeImageModal && (
                    <BannerImageDialog
                        opened={this.state.showLargeImageModal}
                        dialogDidClose={() => this.closeBannerImageDialog()}
                        dialogRef={this.dialogRef}
                        options={{bgClickClose: true}}>
                        <img
                            src={this.state.currentLargeImage}
                            alt="Large Image"
                            className="large-image"
                        />
                    </BannerImageDialog>
                )}

                <Dialog
                    opened={uploadImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('uploadImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('task_details_confirm_upload_image')}
                        </h5>
                        <div className="tag-upload-dialog-desc text-center">
                            <BaseImageUploader
                                className="upload-method-upload text-center"
                                onClickOfSingleTap={this.chooseImage}>
                                {chooseImage && chooseImage.url ? (
                                    <img src={chooseImage.url} alt="" />
                                ) : (
                                    <>
                                        <span className="upload-method-upload-icon" />
                                        <span className="upload-method-upload-text">
                                            {T('task_details_upload_here')}
                                        </span>
                                    </>
                                )}
                                <input
                                    ref="inputFile"
                                    type="file"
                                    accept="image/*"
                                    onChange={this.selectedImage}
                                />
                            </BaseImageUploader>
                        </div>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                loading={loading}
                                onClickOfSingleTap={() =>
                                    this.uploadConfirmHandle()
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'uploadImageDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={previewImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="tag-preview-dialog">
                        <p id="testImage" className="text-center"></p>
                        <div className="tag-preview-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'previewImageDialogOpened',
                                    )
                                }>
                                {T('shopping_cart_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {taskManagement, stManagement, host} = state;
    return {
        taskDetailsData: taskManagement.taskDetailsData,
        queryKey: stManagement.taskDetailsSearchfields.queryKey,
        customerQuestionDetailsData: taskManagement.customerQuestionDetailsData,
        closenessList: taskManagement.closenessList,
        taskDetailMessageCount: taskManagement.taskDetailMessageCount,
        onKeyReadMessage: taskManagement.onKeyReadMessage,
        previewData: host.previewData,
    };
};

const mapDispatchToProps = {
    getOrderDetails,
    getTaskDetails,
    getTaskDetailsFromMessage,
    getStManagementList,
    submitTask,
    openNotification,
    uploadReceiveImage,
    previewTagUploadImage,
    getSysDict,
    getTaskDetailMessageCount,
    getTaskDetailOneKeyRead,
    updateTaskAssignmentSearchfields,
    setFromTaskDetailToMessageListPage,
    setOrderRelatedTaskStatus,
    setCurrentStNum,
    setShipmentsSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetails);
